import { acceptHMRUpdate, defineStore } from 'pinia'
import { api } from './api'
import { sleep } from '@/utils'
import { $removeToken, $setToken } from '@/helpers'

export const useLoadingStore = defineStore({
  id: 'loading',
  state: () => ({
    visible: false,
  }),
  actions: {
    $showLoading() {
      this.$state.visible = true
    },
    $hideLoading() {
      this.$state.visible = false
    },
  },
})

export const useToastStore = defineStore({
  id: 'toast',
  state: () => ({
    message: '',
  }),
  actions: {
    async $toast(message: string, duration = 1500) {
      this.message = message
      await sleep(duration)
      this.message = ''
    },
  },
})

export const useConfigStore = defineStore({
  id: 'config',
  state: () => ({
    _fetched: false,
    xxx: '',
  }),
  actions: {
    async init() {
      if (this.$state._fetched)
        return
      // TODO: fetch `global/config`
      const data = {}
      // const { data } = await api.get<any, any>('/global/config')
      this.$state = { ...this.$state, ...data, _fetched: true } as any
    },
  },
})

export const useUserStore = defineStore({
  id: 'user',
  state: () => ({
    _fetched: false,
    name: '',
    parent_name: '',
    phone: '',
    avatar: '',
    has_openid: 0,
    have_escort_total: 0,
    my_user_total: 0,
  }),
  actions: {
    async login(token: string) {
      $setToken(token)
      await this.init()
    },
    logout() {
      this.$reset()
      $removeToken()
    },
    async init(options: { force: boolean } = { force: false }) {
      if (this.$state._fetched && !options.force)
        return

      try {
        const { data } = await api.get('/escort/user/info')
        this.$state = { ...this.$state, ...data, _fetched: true } as any
      }
      catch (error) {
        console.error(error)
        // Handle error, maybe token expired
        $removeToken()
        window.location.reload()
      }
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useConfigStore, import.meta.hot))
  import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot))
}
